// extracted by mini-css-extract-plugin
module.exports = {"fullheight":"PageSection_fullheight__2oF9A","darkGreen":"PageSection_darkGreen__2R2Aj","green":"PageSection_green__3_jWu","begie":"PageSection_begie__2F5qi"};